export const generateHelpLink = ({
  account,
  accountName,
}: {
  account: string;
  accountName: string;
}) => {
  return `https://open.wikey.io/accountRecover?t=recover&pk=${account}&tn=${accountName}`;
};
